<div class="right-side-container flex flex-col full-grow-no-shrink-no-basis " >
  <app-icon-view (iconViewItemClicked)="iconViewItemClicked($event)" [isClientDrive]="isClientDrive" parentId="">
  </app-icon-view>
  <div class="m-l-28 m-b-30 m-r-30 app-file-store-root-wrapper flex flex-col full-grow-no-shrink-no-basis " >
    <app-file-store-expansion-panel
      *ngIf="magicLinkModel"
      [magicLinkModel]="magicLinkModel">
    </app-file-store-expansion-panel>
  </div>
</div>
